<div class="sam-form-flex-row sam-form-auto sam-center">
   <div class="icon-width sam-center">
      <ng-container *ngIf="isLinked$ | async; else NotLinked">
         <fa-icon [icon]="waveIcon" [fixedWidth]="true"></fa-icon>
      </ng-container>
      <ng-template #NotLinked>
         <div
            class="sam-full-height sam-no-margin sam-no-padding"
            kendoTooltip
            [title]="'common.settings.agent_greetings.no_assignment_warning' | translate"
         >
            <fa-icon class="no-link" [icon]="waveIconNoLink" [fixedWidth]="true"></fa-icon>
         </div>
      </ng-template>
   </div>

   <samweb-text-with-overflow-tooltip
      class="sam-margin-left text-width"
      [value]="wave.name"
      [searchValues]="searchValues"
   ></samweb-text-with-overflow-tooltip>

   <div class="clear-button sam-clickable icon-width sam-center clear-icon">
      <div [ngClass]="{ 'sam-display-none': !(displayClear && !(wave | isNil | async)) }">
         <div
            class="sam-full-height sam-no-margin sam-no-padding"
            kendoTooltip
            [title]="tooltipTranslation | translate"
            (click)="clear()"
         >
            <fa-icon [icon]="clearFilterIcon" [fixedWidth]="true"></fa-icon>
         </div>
      </div>
   </div>
</div>
